<template>
	<section class="events main-content align-left">
		<div class="row row-header align-left">
			<h2 v-if="subtitle" class="subtitle">{{ subtitle }}</h2>
			<div class="columns column12">
				<h2>{{ header }}</h2>

				<a
					v-if="moreButtonLabel"
					class="button button-no-fill"
					href="https://wpevents.be"
					target="_blank"
					rel="noopener noreferrer"
				>
					{{ moreButtonLabel }}
				</a>
			</div>
		</div>
		<events-overview :items="eventblocks" :amount="4" />
	</section>
</template>

<script setup>
// const localePath = useLocalePath();

defineProps({
	subtitle: { type: String, default: '' },
	eventblocks: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
	header: { type: String, default: '' },
	moreButtonLabel: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.row-header {
	max-width: 1680px;
	padding: 0 16px;
}

.columns {
	padding: 0;
	display: flex;
	justify-content: space-between;
}

.button {
	align-self: center;
	margin: 0;

	&:hover {
		background: var(--cta-color);
	}
}

.events {
	background: var(--header-color);

	.columns {
		h2 {
			padding-right: 10px;
			color: #fff;
		}
	}
}

@media (max-width: 550px) {
	.events {
		.columns {
			flex-flow: column;

			.button-no-fill,
			h2 {
				width: 100% !important;
			}
		}
	}
}
</style>
